import { Fragment } from "react";
import { useContent } from "../../lib/content";

export const Marquee = () => {
  const items = useContent().home.marquee;
  const list = Array.isArray(items) && items.length ? items : [];
  if (!list.length) return null;
  const row = (k) => (
    <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
      {list.map((t, i) => (
        <Fragment key={i}>
          <span className={`font-display italic font-black text-5xl sm:text-7xl lg:text-8xl px-6 sm:px-10 whitespace-nowrap ${i % 2 ? "text-outline" : "text-white/90"}`}>{t}</span>
          <span className={`w-3 h-3 sm:w-4 sm:h-4 rotate-45 shrink-0 ${i % 3 === 0 ? "bg-[#ff5500]" : i % 3 === 1 ? "bg-[#4fc3f7]" : "bg-[#3b6ef0]"}`} />
        </Fragment>
      ))}
    </div>
  );
  return (
    <section data-testid="marquee-section" className="relative py-10 sm:py-14 border-y hairline overflow-hidden bg-[#070c18]">
      <div className="flex w-max animate-marquee">{row(0)}{row(1)}</div>
    </section>
  );
};
